import { units, Typography } from '@hbf/dsl';
import { ConversationChat1Light, HourglassAlternateBold } from '@ha/icons';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useIntl } from 'ha/i18n';
import { UserEntity } from 'ha/types/UserEntity';
import { getResponseTimeString } from 'ha/utils/getResponseTimeString';

const useStyles = makeStyles()(() => ({
  root: {
    padding: units.txb(0, 1, 1),
  },
  icon: {
    fontSize: units.rem(0.75),
    marginRight: units.rem(0.5),
  },
}));

interface Props {
  user: UserEntity;
}

const UserCardResponseDetails: React.FC<Props> = ({ user }) => {
  const { T } = useIntl();
  const { classes } = useStyles();

  if (!user.responseRate && !user.responseTime) {
    return null;
  }

  return (
    <div
      className={classes.root}
      data-test-locator="User Card Response Details"
    >
      {user.responseRate > 0 ? (
        <Typography.Caption overflow="ellipsis">
          <ConversationChat1Light className={classes.icon} fontSize="small" />
          {`${T('Response rate')}: `}
          <strong>{Math.round(user.responseRate * 100)}%</strong>
        </Typography.Caption>
      ) : null}

      {user.responseTime ? (
        <Typography.Caption overflow="ellipsis">
          <HourglassAlternateBold className={classes.icon} fontSize="small" />
          {`${T('Response time')}: `}
          <strong>{T(getResponseTimeString(user.responseTime))}</strong>
        </Typography.Caption>
      ) : null}
    </div>
  );
};

export { UserCardResponseDetails };
